import React from 'react'

import {
  remindersCatalogActions,
  remindersCatalogSelectors,
} from '~/store/duck/remindersCatalog'

import AddCatalogItemsDialog, {
  type AddCatalogItemsDialogProps,
} from './AddCatalogItemsDialog'

interface AddReminderProtocolItemsDialogProps
  extends Omit<AddCatalogItemsDialogProps, 'actions' | 'selectors'> {
  patientId?: string
}

const AddReminderProtocolItemsDialog = (
  props: AddReminderProtocolItemsDialogProps,
) => (
  <AddCatalogItemsDialog
    actions={remindersCatalogActions as AddCatalogItemsDialogProps['actions']}
    selectors={
      remindersCatalogSelectors as AddCatalogItemsDialogProps['selectors']
    }
    {...props}
    patientId={props.patientId}
  />
)

export default AddReminderProtocolItemsDialog
